// extracted by mini-css-extract-plugin
module.exports = {"container":"_d7226b","ellipsis":"_705f48","formControl":"_8aa170","iconInfo":"_8d9d60","menuItemAboutSorting":"_8c0bd2","icon":"_789c70"};